import { DjayVariant } from '../DjayAvatar';
export type AchievementRarity = 'common' | 'uncommon' | 'rare' | 'legendary';
export interface DjayIllustrationProps {
  /** The specific achievement ID this illustration is for */
  achievementId: string;
  /** The color scheme to use (defaults to 'default') */
  variant?: DjayVariant;
  /** Whether the achievement is unlocked (true = full color, false = silhouette) */
  isUnlocked: boolean;
  /** The rarity determines glow/shimmer effects */
  rarity: AchievementRarity;
  /** Size context for the illustration */
  size?: 'sm' | 'md' | 'lg';
  /** Whether to play idle animations */
  animate?: boolean;
  /** Additional CSS classes */
  className?: string;
}